'use client';

import CTAButton from '../CTAButton';

const HeroSection = () => {
  return (
    <section className='text-center pt-40 pb-20 px-6 max-w-[820px] mx-auto relative'>
      {/* Badge */}
      <div
        className='inline-flex items-center gap-2 px-5 py-2 border border-border rounded-full text-[13px] font-medium mb-10 text-primary'
        style={{
          background: 'rgba(124, 58, 237, 0.04)',
          animation: 'fadeUp 0.6s ease both',
        }}
      >
        ⚡ Multi-Layer Scheduling
      </div>

      {/* Heading */}
      <h1
        className='font-display font-black tracking-[-0.045em] leading-[1.0] mb-7'
        style={{
          fontSize: 'clamp(44px, 6.5vw, 80px)',
          animation: 'fadeUp 0.6s 0.1s ease both',
        }}
      >
        Schedule. Execute.
        <br />
        <span className='gradient-strong'>Ship Together.</span>
      </h1>

      {/* Subtitle */}
      <p
        className='text-[hsl(var(--text-secondary))] max-w-[540px] mx-auto mb-11 leading-[1.7]'
        style={{
          fontSize: 'clamp(16px, 1.8vw, 20px)',
          animation: 'fadeUp 0.6s 0.2s ease both',
        }}
      >
        Everything your team needs to play together — calendar, tasks, documents, and more. Works solo, but becomes
        unstoppable when your team joins in.
      </p>

      {/* CTA Buttons */}
      <CTAButton />

      <style>{`
        @keyframes btnFire {
          0%, 100% { filter: brightness(1.1); }
          50% { filter: brightness(1.3); }
        }
        @keyframes firePulse {
          0% { opacity: 0.5; transform: scaleY(0.9); }
          100% { opacity: 0.9; transform: scaleY(1.1); }
        }
      `}</style>

      {/* Trust Badges */}
      <div
        className='flex items-center justify-center gap-10 flex-wrap pt-12'
        style={{ animation: 'fadeUp 0.6s 0.4s ease both' }}
      >
        <div className='flex items-center gap-3'>
          <div
            className='w-10 h-10 rounded-xl flex items-center justify-center text-lg'
            style={{ background: 'rgba(124, 58, 237, 0.08)' }}
          >
            ⭐
          </div>
          <div className='text-left'>
            <strong className='block text-[13px] font-bold text-foreground'>Techstars Perks Program</strong>
            <span className='text-xs text-muted-foreground'>Internal Partner</span>
          </div>
        </div>
        <div className='flex items-center gap-3'>
          <div
            className='w-10 h-10 rounded-xl flex items-center justify-center text-lg'
            style={{ background: 'rgba(0, 200, 83, 0.08)' }}
          >
            🫀
          </div>
          <div className='text-left'>
            <strong className='block text-[13px] font-bold text-foreground'>AI-Powered</strong>
            <span className='text-xs text-muted-foreground'>Human-Driven</span>
          </div>
        </div>
        <div className='flex items-center gap-3'>
          <div
            className='w-10 h-10 rounded-xl flex items-center justify-center text-lg'
            style={{ background: 'rgba(255, 153, 0, 0.08)' }}
          >
            ☁️
          </div>
          <div className='text-left'>
            <strong className='block text-[13px] font-bold text-foreground'>Powered by AWS</strong>
            <span className='text-xs text-muted-foreground'>AWS Startup</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
